<template>
    <v-container fluid class="main-container container-fixed h-100 d-block pa-0">
        <div class="content-block">
            <HomeTitle v-model="room"></HomeTitle>
            <BottomSheet
                v-if="locations && locations.length > 6"
                ref="BottomSheet"
                :activeGroup="activeGroup"
                :locations="locations"
                :offset="hasOffline ? 3 : 2"
                @setRoom="setActiveGroup"
            ></BottomSheet>
            <v-layout row class="locations-group-row" v-dragscroll.x>
                <v-btn
                    v-if="locations && locations.length > 6"
                    class="locations-group__btn mx-1"
                    active-class="locations-group__btn-active"
                    :input-value="hasOffline ? activeGroup > 2 : activeGroup > 1"
                    depressed
                    rounded
                    @click="openSheet"
                >
                    {{chosenLocation}}
                    <div v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')" class="d-inline-flex ml-2" />
                </v-btn>
                <v-btn
                    class="locations-group__btn mx-1"
                    active-class="locations-group__btn-active"
                    v-for="(location, index) in locationsScroll"
                    :key="index"
                    :input-value="activeGroup == index"
                    depressed
                    rounded
                    :id="`location${index}`"
                    @click="setActiveGroup(index)"
                >
                    <div
                        v-if="hasOffline && location == 'Неисправные'"
                        v-html="require('!html-loader!@/assets/icons/info_icon.svg')"
                        class="d-inline-flex size-22"
                    />
                    {{ location }}
                </v-btn>
            </v-layout>
            <v-layout
                id="scroll-target"
                class="devices-list scroll-layout px-6 mt-6"
                column
                v-if="deviceTypes"
                v-scroll:#scroll-target="onScroll"
            >
                <div v-if="devicesFiltered.length == 0 && activeGroup == 0" class="img-center">
                    <v-flex text-center>
                        <div
                            v-html="require('!html-loader!@/assets/images/empty-device-list.svg')"
                            class="d-inline-flex mb-8"
                        />
                        <div class="main-text text-center">
                            Вы пока не добавили ни одного <br> устройства в избранное
                        </div>
                    </v-flex>
                </div>
                <div v-else :key="devicesFiltered.length">
                    <div v-for="(device, index) in devicesFiltered" :key="index">
                        <CardholderDevice v-if="device.device_type == 1" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <SwitchDevice v-if="device.device_type == 2" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <MotionSensorDevice v-if="device.device_type == 3" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <OpeningSensorDevice v-if="device.device_type == 4" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <VentilationDevice v-if="device.device_type == 5" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <LeakSensorDevice v-if="device.device_type == 6" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <ThermometerDevice v-if="device.device_type == 7" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <CurtainsDevice v-if="device.device_type == 8" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <LightingDevice v-if="device.device_type == 9" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <SocketDevice v-if="device.device_type == 10" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <FridgeDevice v-if="device.device_type == 11" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <HeatingDevice v-if="device.device_type == 12" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <WarmFloorDevice v-if="device.device_type == 13" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <WaterShutOffDevice v-if="device.device_type == 14" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <DimmableLightingDevice v-if="device.device_type == 15" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <TVDevice v-if="device.device_type == 16" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <IlluminationSensor v-if="device.device_type == 17" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                        <HumidityDevice v-if="device.device_type == 18" :device.sync="device" @switch-favorite="setFavorite" :showLocation="showDeviceLocation"/>
                    </div>
                </div>
            </v-layout>
        </div>
        <ModalWaiting v-model="openModalWaiting"></ModalWaiting>
    </v-container>
</template>

<script>
import HomeTitle from "../components/HomeTitle";
import BottomSheet from "@/components/BottomSheet.vue";
import deviceTypes from '../plugins/deviceTypes.js';
import CardholderDevice from "@/components/devices-card/CardholderDevice";
import VentilationDevice from "@/components/devices-card/VentilationDevice";
import ThermometerDevice from "@/components/devices-card/ThermometerDevice";
import SwitchDevice from "@/components/devices-card/SwitchDevice";
import MotionSensorDevice from "@/components/devices-card/MotionSensorDevice";
import OpeningSensorDevice from "@/components/devices-card/OpeningSensorDevice";
import LeakSensorDevice from "@/components/devices-card/LeakSensorDevice";
import CurtainsDevice from "@/components/devices-card/CurtainsDevice";
import IlluminationSensor from "@/components/devices-card/IlluminationSensor";
import LightingDevice from "@/components/devices-card/LightingDevice";
import SocketDevice from "@/components/devices-card/SocketDevice";
import FridgeDevice from "@/components/devices-card/FridgeDevice";
import HeatingDevice from "@/components/devices-card/HeatingDevice";
import WarmFloorDevice from "@/components/devices-card/WarmFloorDevice";
import WaterShutOffDevice from "@/components/devices-card/WaterShutOffDevice";
import DimmableLightingDevice from "@/components/devices-card/DimmableLightingDevice";
import HumidityDevice from "@/components/devices-card/HumidityDevice";
import TVDevice from "@/components/devices-card/TVDevice";
import ModalWaiting from "@/components/modals/ModalWaiting";
import { dragscroll } from 'vue-dragscroll';
import {eventBus} from "@/main";

export default {
    name: "HomePage",
    directives: {
        dragscroll: dragscroll,
    },
    components: {
        HomeTitle,
        BottomSheet,
        CardholderDevice,
        VentilationDevice,
        ThermometerDevice,
        SwitchDevice,
        MotionSensorDevice,
        OpeningSensorDevice,
        LeakSensorDevice,
        CurtainsDevice,
        LightingDevice,
        SocketDevice,
        FridgeDevice,
        HeatingDevice,
        WarmFloorDevice,
        WaterShutOffDevice,
        DimmableLightingDevice,
        HumidityDevice,
        TVDevice,
        IlluminationSensor,
        ModalWaiting,
    },
    data() {
        return {
            categories: [ "Избранное",  "Все", ],
            locations: ["Кухня", "Зал", "Спальня", "Ванная комната"],
            activeGroup: 1,
            devices: [],
            deviceTypes: deviceTypes,
            room: null,
            openModalWaiting: false,
        };
    },
    created() {
        eventBus.$on("device", this.updateDevice);
        eventBus.$on("reconnect", this.loadPage);
    },
    beforeDestroy() {
        eventBus.$off("device", this.updateDevice);
        eventBus.$off("reconnect", this.loadPage);
    },
    computed: {
        devicesFiltered() {
            this.devices.forEach((el) => {
                el.show_favorite = true;
            });
            this.devices = this.devices.sort((a, b) => (a.name > b.name) ? 1 : -1);
            if (this.activeGroup == 0) {
                this.devices.forEach((el) => {
                    el.show_favorite = false;
                });
                return this.devices.filter((el) => { return el.is_favorite == true });
            } else if (this.hasOffline && this.activeGroup == 2) {
                return this.devices.filter((el) => { return !el.online });
            } else if (this.activeGroup > 1) {
                return this.devices.filter((el) => { return el.location == this.locations[this.activeGroup] });
            }
            return this.devices;
        },
        locationsScroll() {
            if (this.locations && this.locations.length < 7) {
                return this.locations;
            }
            return this.categories;
        },
        hasOffline() {
            return this.devices.some((el) => !el.online);
        },
        showDeviceLocation() {
            return this.hasOffline ? [0, 1, 2].includes(this.activeGroup) : [0, 1].includes(this.activeGroup);
        },
        chosenLocation() {
            let step = this.hasOffline ? 2 : 1;
            return this.activeGroup > step ? this.locations[this.activeGroup] : "Выберите комнату";
        },
    },
    watch: {
        room(val) {
            if (val) {
                this.getDevices();
                localStorage.RobohomeTZ = val.timezone;
            }
        },
    },
    methods: {
        getDevices() {
            this.locations = [];
            this.scenarios = [];
            this.openModalWaiting = true;
            if (this.categories.length > 2) {
                this.categories.splice(2, 1);
            }
            this.$http.get('/devices/home/devices-list/' + this.room.uid + '/')
                .then((response) => {
                    this.devices = response.data.devices;
                    if (this.devices.filter((el) => { return el.is_favorite == true }).length == 0) {
                        this.activeGroup = 1;
                    }
                    if (this.hasOffline) {
                        this.categories.push("Неисправные");
                    }
                    this.locations = JSON.parse(JSON.stringify(this.categories));
                    if (response.data.locations) {
                        response.data.locations.forEach((el) => {
                            if (el) {
                                this.locations.push(el);
                            }
                        });
                    }
                })
                .finally(() => {
                    this.$nextTick(() => {
                        if (this.$store.state.storeActiveGroup !== null) {
                            let i = this.locations.indexOf(this.$store.state.storeActiveGroup);
                            if (i !== -1) {
                                this.activeGroup = i;
                            }
                        }
                    });
                    this.openModalWaiting = false;
                });
        },
        setFavorite(item) {
            this.$http.put('/homes/home/device/favorites/', {
                device: item.uid,
                is_favorite: !item.is_favorite,
            })
                .then(() => {
                    item.is_favorite = !item.is_favorite;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onScroll(e) {
            this.offsetTop = e.target.scrollTop;
            this.$store.commit('setScroll', this.offsetTop);
        },
        setActiveGroup(index) {
            this.activeGroup = index;
            this.$store.commit("setActiveGroup", this.locations[this.activeGroup]);
        },
        openSheet() {
            this.$refs.BottomSheet.open();
        },
        updateDevice(data) {
            let deviceChanged = this.devices.filter((el) => { return el.uid == data.device.uid })[0];
            let deviceIndex = this.devices.indexOf(deviceChanged);
            data.disabled = false;
            if (data.device && deviceChanged) {
                data.device.is_favorite = deviceChanged.is_favorite;
            }
            this.$set(this.devices, deviceIndex, data.device);
        },
    },
}
</script>

<style lang="scss">
.main-container .devices-list.scroll-layout {
    height: calc(100% - 98px) !important;

    .img-center {
        position: relative;
        top: calc(50% - 98px) !important;
    }
}
</style>